import { Form } from '~/shared/api'
import { DadataRegionModel } from '~/model/Dadata'
import { DictionaryItem } from '~/interfaces/Dictionary'

interface OptionsSelect {
  id: number
  name: string
}

export default class AccountVacancyAboutPositionForm extends Form {
  organization: OptionsSelect | null = null
  position: DictionaryItem | string | null = null
  'employment_type': DictionaryItem | null = null
  'employment_format': number[] | null = null
  region: DadataRegionModel | null = null
  city: DadataRegionModel | null = null
  address: { id: number | string; name: string } | null = null
  salary: number | string = ''
  'internship_image': File | string | null = null
  'internship_start_date': string | null = null
  'internship_end_date': string | null = null
  'is_simple_feedback': boolean = false
  'is_salary_hidden': boolean = false
  'is_accept_handicapped': boolean = false
  'foreign_worker': boolean = false

  toInputData() {
    const position = this.position
    return {
      organization: null,
      organization_value: this.organization?.name,
      position: typeof position === 'object' && position !== null ? position.id : null,
      position_value: typeof position === 'object' && position !== null ? position.name : position || null,
      employment: this.employment_type?.id || null,
      employment_formats: this.employment_format || null,
      internship_start_date: this.internship_start_date,
      internship_end_date: this.internship_end_date,
      internship_image: this.internship_image,
      region: this.region?.id || null,
      workplace: this.city?.id || null,
      address: this.address?.name || null,
      salary: this.salary || null,
      is_salary_hidden: this.is_salary_hidden,
      is_simple_feedback: this.is_simple_feedback,
      foreign_worker: this.foreign_worker,
      is_accept_handicapped: this.is_accept_handicapped
    }
  }
}
